import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NotificationData} from "../../../services/common/websocket-notification.service";

@Component({
  selector: 'app-order-notification',
  templateUrl: './order-notification.component.html',
  styleUrls: ['./order-notification.component.scss']
})
export class OrderNotificationComponent implements OnInit {
  @Input() cookieKey: string;
  @Input() notification:NotificationData;
  @Output() linkClick = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  readNotification() {
    const link = "/orders/shop-orders/"+this.notification.data.attribute.id;
    this.linkClick.emit({key:this.notification.key, link:link, cookieKey:this.cookieKey});
  }

  deleteNotification() {

  }
}
